module.exports = __webpack_public_path__ + "img/id_front.3e6b9e2.png";